import styled from 'styled-components';

export const ThemeContentWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 100px;
  row-gap: 50px;
  margin: 10px;
  padding: 30px;
`;
export const ThemeContentBox = styled.div`
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.12);
`;
export const ThemeNameDisplay = styled.div`
  padding: 5px;
  background-color: #b9b7b7;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
export const ThumbNailWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const ImgWrap = styled.div`
  width: 100%;
  height: 250px;
`;
export const ThemeActionButtonWrap = styled.div`
  display: flex;
`;
export const CustomizeButton = styled.button`
  background-color: #105a94;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 8px;
  cursor: pointer;
`;
